module.exports = __webpack_public_path__ + "4f714f3e8b6a0d7141d9ee4d6374c2d8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-6.png
// module id = 3196
// module chunks = 0